import React, { useState } from 'react'
import { Trans, useTranslation, WithTranslation } from 'react-i18next'
import { FiStar } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { useDispatch, useSelector } from 'react-redux'
import { Label, Link, MenuElement } from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { getAccessToken } from '../../../../../reducers/userAccount/selectors/credentials'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getUserId, isUserNewPackage } from '../../../../../reducers/userAccount/selectors/userAccount'
import { getPanelUrlForEnv } from '../../../../../utils/ApiUrl'
import getFinalValidLicenses from '../../../../../utils/License/getFinalValidLicenses'
import { isEmpty } from 'lodash'
import { validLicenses } from '../../../../../reducers/userAccount/selectors/license'
import Sidebar from '../../../Header/Sidebar'
import { theme } from '../../../../../theme'
import Header from '../../../../../components/Template/Premium/Header/Header'
import { License } from '../../../../../components/Template/Premium'
import { mapLicenseToIcon, mapLicenseToName } from '../../../Header/Menu/Premium/PremiumLicenses'
import { getUserSettings } from '../../../../../reducers/userObject/selectors/settings'
import { is } from '../../../../../components/MediaQuery'

function Premium({
  className,
  size = 1,
}: IWithSize & IClassName & WithTranslation) {
  const key = useSelector(getAccessToken)
  const userId = useSelector(getUserId)
  const [open, setOpen] = useState<boolean>(false)
  const dispatch = useDispatch()
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)

  function toggleOpen() {
    setOpen(!open)
    dispatch({
      isSidebarBlock: false,
      isSidebarOpen: false,
      type: 'toggle left sidebar',
    })
  }

  const {t} = useTranslation()
  const isDesktop = is.desktop()
  const format = useSelector(getUserSettings).dateFormat

  const validLicense = useSelector(validLicenses)

  const finalLicenses = getFinalValidLicenses(validLicense)

  const sub = Object.values(finalLicenses).some(l => {
    return l.some(license => {
      if(!isEmpty(license.sub)) return true
      return false
    })
  })

  function goToPremium() {
    if(!isDesktop) {
      toggleOpen()
      return
    }
    Mixpanel.people.increment(userId, 'Premium Menu Opened', 1)
    Mixpanel.track('Main Menu Premium Item Used', {})
    const panelURL = getPanelUrlForEnv()
    window.location.href = `${panelURL}/index/login?autologinkey=${key}&redirect=/payment`
  }

  return (
    <MenuElement
      size={size}
      alignCenter={true}
      className={`${className}-button`}
    >
      <Sidebar
        closeDrawer={toggleOpen}
        open={open}
        headerIcon={
          <FiStar
            color={theme.colors.palette.greyishBrown}
            size={20}
            style={{ minHeight: 20, minWidth: 20 }}
          />
        }
        headerLabel={t('menu_upgrade')}
        scrollable={true}
      >
        {/*{scopes.premium && (*/}
        {/*  <Button*/}
        {/*    as={Link}*/}
        {/*    style={{ height: '38px', margin: '15px 15px' }}*/}
        {/*    primary={true}*/}
        {/*    onClick={goToPremium}*/}
        {/*  >*/}
        {/*    <ButtonLabel>{t('prolong_access')}</ButtonLabel>*/}
        {/*  </Button>*/}
        {/*)}*/}

        <Header
          active={true}
          label={t('BBO_934_active_services')}
          validLicenses={finalLicenses.active}
          style={{ width: '310px' }}
        />

        {finalLicenses.active.map(license => (
          <License
            icon={mapLicenseToIcon(license)}
            label={t(mapLicenseToName(license, t,isNewPremiumPriceGroup))}
            endTime={license.license}
            rawEnd={license.rawDate}
            sub={license.sub}
            startTime={license.startLicense}
            roomLimit={license.roomLimit}
            formatDate={format.date}
            more={true}
          />
        ))}

        {finalLicenses.awaits.length !== 0 && (
          <>
            <Header
              style={{
                borderTop: `1px solid ${theme.colors.palette.emerald}`,
                width: '310px',
              }}
              active={false}
              label={t('BED_5438_pending_services')}
              validLicenses={finalLicenses.awaits}
            />

            {finalLicenses.awaits.map(license => (
              <License
                icon={mapLicenseToIcon(
                  license,
                  1,
                  theme.colors.palette.slateGrey,
                )}
                label={t(mapLicenseToName(license, t,isNewPremiumPriceGroup))}
                endTime={license.license}
                sub={license.sub}
                awaits={true}
                rawEnd={license.rawDate}
                startTime={license.startLicense}
                roomLimit={license.roomLimit}
                formatDate={format.date}
                more={true}
              />
            ))}
          </>
        )}
      </Sidebar>
      <Link size={size} to={sub && isDesktop? '/premium':'#'} onClick={sub && isDesktop?undefined:goToPremium}>
        <Flex alignCenter={true}>
          <b>
            <FiStar size={16 * size} />
          </b>
          <Label size={size} primary={true} className={`${className}-label`}>
            <Trans i18nKey={'menu_upgrade'}>Premium</Trans>
          </Label>
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default Premium

export interface IClassName {
  className?: string
}
